import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { SafetyOutlined } from '@ant-design/icons';
import { ReservationContext } from 'context/ReservationProvider';

import { Button } from 'components/common/Button';

import useWindowSize from 'library/hooks/useWindowSize';

import {
  ActionsWrapper,
  SecurePaymentDescription
} from './CardForm.style';

const CardAction = ({
  user,
  reservation,
  intent,
  enablePaymentButton,
  setEnablePaymentButton,
  showCardError,
  setShowCardError,
  error,
  setError,
  acceptDisabled,
  onConfirmReservation,
  onMouseUp,
  CardElement
}) => {
  const { width } = useWindowSize();
  const { t } = useTranslation();
  const { updateReservationPayment } = useContext(ReservationContext);

  const stripe = useStripe();
  const elements = useElements();

  const payWithStripe = async usePopeyeBalance => {
    if (!enablePaymentButton || !stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return false;
    }
    let result = await stripe.confirmCardPayment(intent, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name: `${user.first_name} ${user.last_name}`
        }
      }
    });

    if (result.error) {
      // Show error to your customer (e.g., insufficient funds)
      setError(result.error);
      setShowCardError(true);
      // console.log(result.error.message);
      return { error: result.error };
    } else {
      // The payment has been processed!
      if (result.paymentIntent.status === 'succeeded') {
        setShowCardError(false);
        setError(null);
        // Show a success message to your customer
        // There's a risk of the customer closing the window before callback
        // execution. Set up a webhook or plugin to listen for the
        // payment_intent.succeeded event that handles any business critical
        // post-payment actions.
        // console.log('Success', result);
        //get id from result
        result = await updateReservationPayment({
          reservation_id: reservation.id,
          stripe_transaction_id: result.paymentIntent.id,
          use_popeye_balance: usePopeyeBalance
        });

        return result;
      }
    }
  };

  const handleConfirmReservation = () => {
    if (enablePaymentButton) {
      onConfirmReservation(payWithStripe, enablePaymentButton);
      setShowCardError(false);
    } else {
      setShowCardError(true);
      elements.getElement(CardElement).focus();
    }
  };

  return (
    <ActionsWrapper>
      <Button
        fillWidth
        disabled={!enablePaymentButton || !stripe || acceptDisabled}
        label={t('RESERVATION_CONFIRM_RESERVATION')}
        onClick={handleConfirmReservation}
        onMouseUp={onMouseUp}
      />
      <SecurePaymentDescription>
        <SafetyOutlined style={{ fontSize: 24, color: '#828282' }} />
        <p>{t('RESERVATION_SAVE_AND_SECURE_PAYMENT')}</p>
      </SecurePaymentDescription>
    </ActionsWrapper>
  )
};

export default CardAction;
